import React, { useEffect, useState } from 'react';
import { IonButton, IonSpinner, IonText } from '@ionic/react';
import { billing } from '../services/api.ts';
import './BalanceDisplay.css';

interface BalanceDisplayProps {
  onClick?: () => void;
}

const BalanceDisplay: React.FC<BalanceDisplayProps> = ({ onClick }) => {
  const [balance, setBalance] = useState<number | null>(null);
  const [balanceDisplay, setBalanceDisplay] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadBalance = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await billing.getBalance();
        setBalance(response.balance);
        setBalanceDisplay(response.balance_display);
      } catch (err: any) {
        console.error('Failed to load balance:', err);
        setError(err.message || 'Failed to load balance');
      } finally {
        setLoading(false);
      }
    };

    // Load immediately
    loadBalance();

    // Poll every 2 minutes (balance doesn't change frequently)
    const interval = setInterval(loadBalance, 120000);

    return () => clearInterval(interval);
  }, []);

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  // Format balance if not provided by SSE
  const formatBalance = (credits: number) => {
    return `$${(credits / 100).toFixed(2)}`;
  };

  if (loading) {
    return (
      <IonButton fill="clear" size="small" disabled>
        <IonSpinner name="crescent" />
      </IonButton>
    );
  }

  if (error || balance === null) {
    return (
      <IonButton fill="clear" size="small" disabled>
        <IonText color="medium">--</IonText>
      </IonButton>
    );
  }

  const isLowBalance = balance < 100;
  const displayText = balanceDisplay || formatBalance(balance);

  return (
    <IonButton
      fill="clear"
      size="small"
      onClick={onClick}
      className="balance-display-button"
      title="Balance"
    >
      <IonText color={isLowBalance ? "danger" : "success"}>
        {displayText}
      </IonText>
    </IonButton>
  );
};

export default BalanceDisplay;
